export function addListenerForRouteChangesInSPA(callback) {
  const oldPushState = history.pushState
  history.pushState = function pushState() {
    oldPushState.apply(this, arguments)
    callback(arguments)
  }

  const oldReplaceState = history.replaceState
  history.replaceState = function replaceState() {
    oldReplaceState.apply(this, arguments)
    callback(arguments)
  }
}
